import { State } from './types';

const sidebarOpen = (state: State) => state.sidebarOpen;

export default {
  sidebarOpen,
};
